import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { isSupportedForDomain } from '../../jsCore/application/pageDataObject'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { TWITTER, EMBED, WHATSAPP } from '../../jsCore/organizedByType/config/socialButtonsConfig'
import { getSocialButtonsConfig } from '../../jsCore/store/config/config.selectors'
import {
  getIsMobile,
  getIsMobileOrTablet,
} from '../../jsCore/store/userDevice/userDevice.selectors'
import {
  excludedComponentsForSite,
  isComponentSupportedForSite,
} from '../../jsCore/store/featureFlags/featureFlags.selectors'
import { SocialButtonOrLink } from './components/SocialButton.view'
import { shareButtonsAnalyticsAction } from '../../jsCore/organizedByType/actions/analyticsActions'

const SOCIAL_BUTTONS_FEATURE_ID = 'SocialButtons'

const COMPONENT_NAME = 'SocialButtonsComponent'

const HEADER_POSITION = 'header'

class SocialButtons extends React.Component {
  onClick({ target }) {
    this.props.shareButtonsAnalyticsAction(
      target.title,
      this.props.options.dataset.position.replace('-', ' ')
    )
  }

  render() {
    const socialButtonsProps = {
      className: `share-component share-component--${this.props.options.dataset.position}`,
      children: this.props.buttons.map(SocialButtonOrLink),
      onClick: this.onClick.bind(this),
    }
    return <div {...socialButtonsProps} />
  }
}

const getPosition = (state, props) => props.options.dataset.position

const createIsComponentSupportedForSite = state =>
  isComponentSupportedForSite(state, SOCIAL_BUTTONS_FEATURE_ID)

function filterOutWhatsappOnNonMobile(isMobile, item) {
  return isMobile || item !== WHATSAPP
}

function filterOutEmbedOnMobileAndTablet(isMobileOrTablet, item) {
  return !isMobileOrTablet || (isMobileOrTablet && item !== EMBED)
}

function filterOutEmbedOnHeader(position, item) {
  return position !== HEADER_POSITION || (position === HEADER_POSITION && item !== EMBED)
}

function filterOutExcludedComponentsForSite(excludedFeatures, item) {
  return !excludedFeatures.some(excluded => excluded === item)
}

function openWhatsappInSameTab(button) {
  return button.name === WHATSAPP
    ? {
        ...button,
        openInSameTab: true,
      }
    : button
}
const getSocialButtonsSelector = createSelector(
  [
    getSocialButtonsConfig,
    getIsMobile,
    getIsMobileOrTablet,
    createIsComponentSupportedForSite,
    getPosition,
    excludedComponentsForSite,
  ],
  (socialButtonsConfig, isMobile, isMobileOrTablet, isSupported, position, excludedFeatures) => {
    return Object.values(socialButtonsConfig)
      .filter(() => isSupported)
      .filter(({ name }) => filterOutEmbedOnMobileAndTablet(isMobileOrTablet, name))
      .filter(({ name }) => filterOutWhatsappOnNonMobile(isMobile, name))
      .filter(({ name }) => filterOutEmbedOnHeader(position, name))
      .filter(({ name }) => filterOutExcludedComponentsForSite(excludedFeatures, name))
      .map(button => openWhatsappInSameTab(button))
  }
)
const makeMapStateToProps = (state, props) => ({ buttons: getSocialButtonsSelector(state, props) })

const mapDispatchToProps = { shareButtonsAnalyticsAction }

export const SocialButtonsComponent = connect(makeMapStateToProps, mapDispatchToProps)(
  SocialButtons
)

const socialButtonsMountDetails = {
  name: COMPONENT_NAME,
  component: SocialButtonsComponent,
}
function mountSocialButtons() {
  return reduxMount({
    [MOUNT_POINTS.SHARE_COMPONENT]: socialButtonsMountDetails,
  })
}

export function initSocialButtons() {
  const shouldMountSocialButtons = isSupportedForDomain(SOCIAL_BUTTONS_FEATURE_ID)
  if (shouldMountSocialButtons) {
    mountSocialButtons()
  }
  return shouldMountSocialButtons
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/social_buttons/socialButtons.container.js